// components/BuildMode.js
import React from 'react';
import tablesGraphic from '../../src/assets/img/about/watchedPot.gif';

const BuildMode = () => {
  return (
    <div className="w-full h-screen flex flex-col bg-white text-center">

      {/* Top gradient */}
      <div className="w-full h-[200px] bg-gradient-to-b from-[#ffc9cd] to-white" />

      {/* Center content */}
      <div className="flex flex-col items-center justify-center flex-grow space-y-4 select-none">

        <p className="text-2xl" style={{ color: '#ca895f' }}>
          GoHost site is currently under construction
        </p>

        <img
          src={tablesGraphic}
          alt="Under Construction"
          className="w-40 h-40 object-contain"
        />

        <p
          className="text-xl max-w-[450px] leading-snug mx-auto"
          style={{ color: '#df001b' }}
        >
          “The discovery of a new dish does more for the happiness of mankind than the discovery of a new star.”
        </p>

        <p className="text-lg italic" style={{ color: '#df001b' }}>
        — Jean Anthelme Brillat-Savarin
        </p>
      </div>

      {/* Bottom gradient */}
      <div className="w-full h-[200px] bg-gradient-to-t from-[#efd6c5] to-white" />

    </div>
  );
};

export default BuildMode;
